import { resolveReq, axios } from '../utils/api'

export const getCovidList = async () => {
  const { data, error } = await resolveReq(axios.get('/api/informational/getcovidlist'))
  if (error) return console.error(error.message)

  return data
}
